import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from 'src/app-redux/rtkq.interceptor';
import { transformResponses } from 'src/app-redux/rtkq.interceptor';
import { apiResources } from 'src/common/Constants';
import { CreateFuelPumpsArgs, FetchFuelPumpsArgs, FuelPump } from 'src/management/FuelPump';

const fuelPumpsTag = 'fuelPumps';

/** RTK Query API slice for fuel pump management endpoints. */
export const fuelPumpsApi = createApi({
  reducerPath: 'fuelPumpsApi',
  tagTypes: [fuelPumpsTag],
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    /** Query to fetch all fuel pumps with pagination and search. */
    fetchAllFuelPumps: builder.query<FuelPump[], FetchFuelPumpsArgs>({
      query: (args) => ({
        url: `${apiResources.fuelPump}/all`,
        method: 'GET',
        params: { page: args.page, [args.searchBy]: args.fuelPumpName },
      }),
      ...transformResponses,
      providesTags: [fuelPumpsTag],
    }),
    /** Mutation to create a new fuel pump. */
    createFuelPump: builder.mutation<void, CreateFuelPumpsArgs>({
      query: (args) => ({
        url: `${apiResources.fuelPump}/create`,
        method: 'POST',
        body: args,
      }),
      invalidatesTags: (_result, error) => (error ? [] : [fuelPumpsTag]),
    }),
  }),
});

/** RTK Query hooks for fuel pump management endpoints. */
export const { useFetchAllFuelPumpsQuery, useLazyFetchAllFuelPumpsQuery, useCreateFuelPumpMutation } = fuelPumpsApi;
